import React from 'react';
import { DAY_START, HOUR_HEIGHT, MIN_ENTRY_PX } from '../lib/calendar.js';
import { fmtDur, fmtTime } from '../lib/time.js';
import { ProjectLabel } from './ui.jsx';

// A provisional "to-be" block for a running timer: the same footprint as a
// saved entry but a dashed neutral-gray placeholder. The live slice (the one
// growing towards the now-line) carries a blinking red dot; earlier paused
// slices are settled and quiet. Clicking it jumps back to the timer bar since
// it isn't a real entry yet.
export function CalendarGhost({
  block,
  project,
  live,
  hourHeight = HOUR_HEIGHT,
  onFocusTimer,
}) {
  const duration = block.end - block.start;
  const projectData = project || {
    code: '--',
    name: 'Timed work',
    color: 'slate',
  };
  const projectText = [projectData.code, projectData.name]
    .filter(Boolean)
    .join(' ');
  const tooltip = `${projectText} · ${fmtDur(duration)} (${fmtTime(
    block.start,
  )} - ${fmtTime(block.end)}) · ${live ? 'recording' : 'paused'}`;

  return (
    <button
      type="button"
      className={`cal-ghost ${live ? 'cal-ghost-live' : 'cal-ghost-settled'}`}
      aria-label={tooltip}
      data-tooltip={tooltip}
      // Don't let the press start a create-drag on the day column beneath.
      onMouseDown={(event) => event.stopPropagation()}
      onClick={(event) => {
        event.stopPropagation();
        onFocusTimer?.();
      }}
      style={{
        top: (block.start - DAY_START) * hourHeight,
        height: Math.max(MIN_ENTRY_PX, duration * hourHeight),
      }}
    >
      <div className="cal-ghost-top">
        {live && <span className="cal-ghost-dot" aria-hidden="true" />}
        <ProjectLabel project={projectData} />
        <span className="cal-ghost-dur">{fmtDur(duration)}</span>
      </div>
    </button>
  );
}
